import ClassicTheme from "./themes/ClassicTheme";
import SportsTheme from "./themes/SportsTheme";
import ModernTheme from "./themes/ModernTheme";
import MinimalTheme from "./themes/MinimalTheme";
import DarkTheme from "./themes/DarkTheme";
import ArenaTheme from "./themes/ArenaTheme";
import BoxArenaTheme from "./themes/BoxArenaTheme";
import PicklePointTheme from "./themes/PicklePointTheme";
import MerlionTheme from "./themes/MerlionTheme";
import BsaTheme from "./themes/BsaTheme";
import TurfParkTheme from "./themes/TurfParkTheme";
import BoxArenaCourtlineTheme from "./themes/BoxArenaCourtlineTheme";

export const THEME_COMPONENTS =
  Object.freeze({
    classic: ClassicTheme,
    modern: ModernTheme,
    sports: SportsTheme,
    minimal: MinimalTheme,
    dark: DarkTheme,
    arena: ArenaTheme,
    "box-arena": BoxArenaTheme,
    "pickle-point-nepal": PicklePointTheme,
    "merlion-gymnasium": MerlionTheme,
    "bhaisepati-sports-academy": BsaTheme,
    "turf-park": TurfParkTheme,
    "boxarena-courtline": BoxArenaCourtlineTheme,
  });

export const findThemeComponent = (
  layout,
) =>
  THEME_COMPONENTS[layout] ||
  null;

export const getThemeComponent = (
  layout,
) =>
  findThemeComponent(layout) ||
  THEME_COMPONENTS.classic;